import Popup from 'components/Popup';
import { useError } from 'context/ErrorContext';
import { useTranslation } from 'react-i18next';
import { POPUP_STATUS } from '../../entities';

const ErrorPopup = () => {
  const { error, setError } = useError();
  const { t } = useTranslation();

  const handleConfirm = () => (error?.onConfirm ? error.onConfirm() : setError(null));

  return (
    <Popup
      isOpen={!!error}
      title={error?.title || t('systemWarning')}
      content={error?.message || ''}
      status={POPUP_STATUS.WARNING}
      confirmTitle={error?.confirmTitle || t('confirm')}
      onConfirm={handleConfirm}
    />
  );
};

export default ErrorPopup;
